<div class="attachment-container">
    <p class="title" *ngIf="!onlyUploadImages && !isNotDisplayLabel">
        {{ 'addAttachments' | translate }}
    </p>
    <p class="title" *ngIf="onlyUploadImages && !isNotDisplayLabel">
        {{ 'addImageAttachments' | translate }}
    </p>
    <!-- Browse -->
    <div class="browse" [ngClass]="{ disable: isDisable }">
        <div class="drag-drop-container" (paste)="handlePaste($event)" role="button">
            <ngx-file-drop
                dropZoneLabel="Drop files here"
                (onFileDrop)="dropped($event)"
                [directory]="false"
                accept="{{ allowedAttachmentExtensionsWithoutDot }}"
            >
                <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                    <div class="d-flex align-items-baseline">
                        <div class="add-attachment-image">
                            <img src="assets/images/upload_3_line.svg" alt="placeholder-image" />
                        </div>
                        <div class="drag-drop-text mx-2">
                            {{ 'dragAndDropFile' | translate }}
                            <span> {{ 'past' | translate }} </span> {{ 'or' | translate }}
                            <span class="browser-file" (click)="openFileSelector()">{{ 'browser' | translate }} </span>
                        </div>
                    </div>
                </ng-template>
            </ngx-file-drop>
        </div>
        <!-- Max File Size -->
        <div class="max-file-size-container">
            <span class="remainingCount"
                >{{ 'maximumFileSize' | translate }}<span class="stc-font-danger"> {{ maxAttachmentSizeInMegaBytes }} {{ 'MB' | translate }} </span>
            </span>
            <span class="dash"> - </span>
            <span class="remainingCount max-attach-number"
                >{{ 'maximumNumberForAttachments' | translate }}
                <span class="stc-font-danger">{{ 'file115' | translate }} </span>
            </span>
            <!-- <div class="hint-as-error" *ngIf="isRequired">
                {{ 'ticketingModule.fieldRequired' | translate }}
            </div> -->
        </div>
    </div>

    <!--  Attachments List (added files and are uploaded) -->
    <div class="attached-files-container">
        <app-attachments-list [attachmentList]="attachmentList" [reportId]="reportId" [requestId]="requestId" [action]="addAttachment"> </app-attachments-list>
    </div>

    <app-upload-attachments [userAttachment]="userAttachment" [requestId]="requestId" [reportId]="reportId" [uploadAttachmentRequestType]="uploadAttachmentRequestType"> </app-upload-attachments>
</div>

<!-- <div (paste)="handlePaste($event)" contenteditable="true" style="border: 2px dashed #ccc; width: 300px; height: 200px">Paste image here</div> -->
